import { withTranslation } from 'react-i18next';

import FormResetPassword from '../../components/Forms/FormResetPassword/FormResetPassword';

export default withTranslation()(FormResetPassword);
